import React from 'react';
import { Badge } from '@ncoder/ui';

interface MonitoringMetricProps {
  label: string;
  value: string;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  icon?: React.ReactNode;
  color?: 'primary' | 'success' | 'warning' | 'destructive';
}

export const MonitoringMetric: React.FC<MonitoringMetricProps> = ({
  label,
  value,
  change,
  changeType = 'neutral',
  icon,
  color = 'primary',
}) => {
  const getColorClass = () => {
    switch (color) {
      case 'success':
        return 'text-green-600 dark:text-green-400';
      case 'warning':
        return 'text-yellow-600 dark:text-yellow-400';
      case 'destructive':
        return 'text-red-600 dark:text-red-400';
      default:
        return 'text-primary';
    }
  };

  const getChangeColor = () => {
    switch (changeType) {
      case 'positive':
        return 'text-green-600 dark:text-green-400';
      case 'negative':
        return 'text-red-600 dark:text-red-400';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        {icon && <span className={getColorClass()}>{icon}</span>}
        <span className="text-sm text-muted-foreground">{label}</span>
      </div>
      <div className="flex items-end justify-between">
        <span className={`text-2xl font-bold ${getColorClass()}`}>{value}</span>
        {change && (
          <span className={`text-xs ${getChangeColor()}`}>{change}</span>
        )}
      </div>
    </div>
  );
};
